import NoSelectedPinIcon from './component'

export default NoSelectedPinIcon
